var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('h2',[_vm._v(_vm._s(_vm.$t("contact_cv")))]),_c('ul',_vm._l((this.cv),function(cvItem){return _c('li',{key:cvItem.path},[_c('a',{attrs:{"href":cvItem.path}},[_vm._v(" "+_vm._s(cvItem.label)+" ")])])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }